import { createApp } from 'vue'
import App from '@/App.vue'
import Antd, { notification } from 'ant-design-vue'
import Router from "@/router";
import NProgress from "nprogress";

import "nprogress/nprogress.css";
import 'ant-design-vue/dist/antd.css';
import server from "@/server";
import store from "@/store";
import i18n, { i18nManager } from "@/i18n/i18n";

NProgress.start();

//设置已经缓存的i18n内容，如果存在
try {
    let locale = window.localStorage.getItem('sso-locale');
    if (locale) {
        i18nManager.setLanguage(locale);
    }
} catch (e) {
    console.error(e);
}

//获取全局信息
server.postForm({
    url: '/getLoginBasicInfo',
    data: {
        md5: '1'
    },
    success: (data) => {
        if (data.code === '0x000000') {
            store.temporary.basicInfo = data.data;
            console.info('Load basic info [Done]');
            if (data.data.productName) {
                document.getElementsByTagName('title')[0].innerHTML = data.data.productName;
            }
            createApp(App)
                .use(Antd).use(i18n).use(Router)
                .mount('#app');
            let themes = (data.data.themes ? data.data.themes.split('/') : []);
            //适配默认黑色模式主题的情况
            if (themes.length > 0 && themes.indexOf('dark') === 0) {
                document.getElementById('app').classList.remove('white-theme');
                document.getElementById('app').classList.add('dark-theme');
            }
            //适配手动切换默认颜色的存储加载
            if (themes.length > 0 && data.data.themeModel === 'switch' && themes.indexOf('dark') >= 0 && window.localStorage.getItem('sso-theme') === 'dark') {
                document.getElementById('app').classList.remove('white-theme');
                document.getElementById('app').classList.add('dark-theme');
            }
        } else {
            notification.open({
                message: i18nManager.text('error.server'),
                description: data.msg,
                duration: null,
                style: 'border-radius: 8px;white-space: pre-wrap!important;',
                placement: 'topLeft',
            });
        }
    },
    error: () => {
        notification.open({
            message: i18nManager.text('error.normal'),
            description: i18nManager.text('error.connectServer'),
            duration: null,
            style: 'border-radius: 8px;white-space: pre-wrap!important;',
            placement: 'topLeft',
        });
    },
    complete: () => {
        NProgress.done();
    }
});
